// extracted by mini-css-extract-plugin
export default {"icon":"icon--rNdWL","main":"main--TPHw0","iconDiv":"iconDiv--O4PMD"};